export default __webpack_public_path__ + "static/media/benutzerIconDark.52f5f10f.svg";